import React, { FunctionComponent } from "react";

import { partTypeTire } from "../../../constants/partTypes";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { getDefaultQuantity } from "../../PriceSelect/getDefaultQuantity";
import { usePriceSelectState } from "../../PriceSelect/usePriceSelectState";
import { usePricing } from "../../PriceSelect/usePricing";
import { TirePartDetails } from "../../Tires/Common/TirePartDetails";
import { partIsStaggered } from "../../Tires/Results/Filters/TireSizeFilters/partIsStaggered";
import { Details } from "../Common/Details";
import { Image } from "../Common/Image";
import { Actions } from "../Common/LeadForm/Actions";
import { PricingNote } from "../Common/PricingNote";
import { Description } from "./Description";
import { ReccommendedFor } from "./ReccommendedFor";
import { Warranty } from "./Warranty";

type TireDetailsProps = {
  part: TirePartItem | null;
};

export const TireDetails: FunctionComponent<TireDetailsProps> = ({ part }) => {
  const isStaggered = partIsStaggered(part);
  const [priceEntries, setPriceEntries] = usePriceSelectState([]);

  usePricing({
    defaultQuantity: getDefaultQuantity({ isStaggered, orderItem: null, part }),
    isStaggered,
    onReady: setPriceEntries,
    part,
  });

  return (
    <div className="grid md:grid-cols-3 gap-4">
      <main className="flex flex-col gap-4 md:col-span-2">
        <Image part={part} />
        <Description part={part} />
        <ReccommendedFor part={part} />
        <Warranty part={part} />
        <PricingNote partType={partTypeTire} />
      </main>
      <aside className="flex flex-col gap-4">
        <Details>
          <TirePartDetails
            isFront={isStaggered}
            isRear={false}
            part={part?.partDetails.primaryPart ?? null}
            rowClassName="justify-between"
          />
          {isStaggered && (
            <>
              <hr className="my-2" />
              <TirePartDetails
                isFront={false}
                isRear={true}
                part={part?.partDetails.secondaryParts[0] ?? null}
                rowClassName="justify-between"
              />
            </>
          )}
        </Details>
        <Actions
          isStaggered={isStaggered}
          part={part}
          priceEntries={priceEntries}
          setPriceEntries={setPriceEntries}
        />
      </aside>
    </div>
  );
};
